// extracted by mini-css-extract-plugin
export default {"title":"AboutContract_title__KgbOL","info":"AboutContract_info__7-XwT","list":"AboutContract_list__y-HcD"};